import { render } from "./IconPrint.vue?vue&type=template&id=27f858d2&lang=html"
import script from "./IconPrint.vue?vue&type=script&lang=js"
export * from "./IconPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__